export default __webpack_public_path__ + "static/media/check-home.0b4219a9.svg";